module.exports = __webpack_public_path__ + "static/img/01_ava_name_cornelius_carstens.3e30ac3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/ava/01_ava_name_cornelius_carstens.png
// module id = glC2
// module chunks = 1